import * as React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { Field } from '@progress/kendo-react-form';
import { FormPage, TextBox } from '../../../ui';
import { loadStudyProgramTheoreticalPartFormPage, saveStudyProgramTheoreticalPart } from '../actions/study-program-theoretical-part-form-page-actions';
import { withRouter } from '../../../components/withRouter';

class StudyProgramTheoreticalPartFormPage extends React.PureComponent {

  constructor() {
    super();
    this.handleValidate = this.handleValidate.bind(this);
    this.handleBreadcrumbItemClick = this.handleBreadcrumbItemClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  async componentDidMount() {
    if (this.props.params?.studyProgramId) {
      await this.props.loadStudyProgramTheoreticalPartFormPage({
        studyProgramId: this.props.params.studyProgramId,
        studyProgramTheoreticalPartId: this.props.params.studyProgramTheoreticalPartId
      });
    }
  }

  render() {
    const localizationService = provideLocalizationService(this);

    return (
      <FormPage
        title={localizationService.toLanguageString('studyProgram.studyProgramTheoreticalPart')}
        breadcrumbItems={[
          {
            id: 'study-programs',
            text: localizationService.toLanguageString('studyProgram.studyPrograms')
          },
          {
            id: 'study-program',
            text: localizationService.toLanguageString('studyProgram.studyProgram')
          },
          {
            id: 'study-program-theoretical-part',
            text: localizationService.toLanguageString('studyProgram.studyProgramTheoreticalPart'),
            disabled: true
          }
        ]}
        onBreadcrumbItemClick={this.handleBreadcrumbItemClick}
        validationResult={this.props.validationResult}
        loading={this.props.loading}
        initialValues={this.props.studyProgramTheoreticalPart}
        localizationService={localizationService}
        onSubmit={this.handleSubmit}
        onCancel={this.handleCancel}
        validator={this.handleValidate}
        render={() => (
          <Field
            name='name'
            label={localizationService.toLanguageString('studyProgram.name')}
            component={TextBox}
            width='320px'
          />
        )}
      />
    );
  }

  handleValidate(values, localizationService, validationResult, modified) {
    const errors = {};
    if (!values.name) {
      errors.name = localizationService.toLanguageString('validation.required');
    }
    if (!modified.name) {
      if (validationResult?.errors?.name) {
        errors.name = validationResult?.errors?.name;
      }
    }
    return errors;
  }

  handleBreadcrumbItemClick(e) {
    if (e.id === 'study-programs') {
      this.props.navigate('/study_programs');
    }
    if (e.id === 'study-program') {
      this.props.navigate(`/study_programs/${this.props.params.studyProgramId}/overview`);
    }
  }

  handleCancel() {
    this.props.navigate(-1);
  }

  handleSubmit(payload) {
    this.props.saveStudyProgramTheoreticalPart(payload);
  }
}

registerForLocalization(StudyProgramTheoreticalPartFormPage);

const mapStateToProps = state => ({
  loading: state.studyProgramTheoreticalPartFormPage.loading,
  studyProgramTheoreticalPart: state.studyProgramTheoreticalPartFormPage.studyProgramTheoreticalPart,
  validationResult: state.studyProgramTheoreticalPartFormPage.validationResult
});

const mapDispatchToProps = dispatch => ({
  loadStudyProgramTheoreticalPartFormPage: (payload) => dispatch(loadStudyProgramTheoreticalPartFormPage(payload)),
  saveStudyProgramTheoreticalPart: (payload) => dispatch(saveStudyProgramTheoreticalPart(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StudyProgramTheoreticalPartFormPage));
